import React from 'react';

import MuiButtonBase, {
  ButtonBaseProps as MuiButtonBaseProps,
} from '@mui/material/ButtonBase';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const ButtonBase = withCoreProps<ButtonBaseProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<ButtonBaseProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiButtonBase {...props} className={clsxClass}>
        {children}
      </MuiButtonBase>
    );
  },
);

export interface ButtonBaseProps extends MuiButtonBaseProps, CoreProps {}
